export enum ProviderProfileReferrerEnum {
  ProviderHubLandingPage,
  ProviderProfile,
  ContractEntityProfile,
  OrganizationProfile,
  HospitalProfile
}
